/* eslint-disable prefer-promise-reject-errors */
/*
 * @Description: 微信相关函数
 * @FilePath: /vue-medweb/packages/vue-m-comprehensive/src/utils/wx.js
 * @Date: 2022-03-06 22:24:47
 * @LastEditTime: 2022-10-19 20:46:29
 */
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import auth from '@/services/auth';
import Vue from 'vue';

const wx = require('weixin-js-sdk');

/**
 * 微信上传工具
 */

const FAIL_TYPES = {
  UPLOAD_FAIL: {
    value: 'UPLOAD_FAIL',
    desc: '上传失败',
  },
  API_FAIL: {
    value: 'API_FAIL',
    desc: '微信接口失败',
  },
};

// 签名
export const wxSdkSign = () => {
  return new Promise((resolve, reject) => {
    console.log('微信签名');
    if (cyDetect.isFromWechat()) {
      cyShare
        .signWeixinJsSdk('/publicwap/wx_js_sdk_sign/?url=')
        .then(res => {
          console.log('签名成功 && 注册api权限成功', res);
          resolve();
        })
        .catch(error => {
          console.log('签名失败', error);
          reject();
        });
    }
  });
};

/**
 * @description 向服务器获取七牛token
 */
export const getToken = () => {
  return new Promise((resolve, reject) => {
    auth
      .getToken()
      .then(res => {
        if (res.success) {
          console.log('获取七牛token成功');
          resolve(res.token);
        } else {
          console.log('获取七牛token失败');
          reject(res);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

/**
 * @description: base64上传七牛，返回图片的url
 * @param {string} base64Str 需要上传base64字符串
 * @param {string} token 七牛上传需要的token
 * @returns {Promise} 成功时，返回图片链接
 */
export function uploadbase64ToQiniu(base64Str = '', token = '') {
  const base64 =
    base64Str.indexOf('base64,') !== -1
      ? base64Str.split('base64,')[1]
      : base64Str;

  const url = 'https://up-z0.qiniup.com/putb64/-1'; // 华北地区七牛仓库位置

  return new Promise((resolve, reject) => {
    // 发请求
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        const data = JSON.parse(xhr.response);
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      }
    };
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    xhr.setRequestHeader('Authorization', `UpToken ${token}`);
    xhr.send(base64);
  });
}

/**
 * 通过 wx.chooseImage 选中图片进行上传
 *
 * @param {object}  optionObject 配置信息 https://developers.weixin.qq.com/miniprogram/dev/api/media/image/wx.chooseImage.html
 * @returns { Promise.resolve([array])}  可选择多个文件，只有全部文件上传成功时，才会返回成功的Promise，接受文件信息list
 */
export const uploadImage = function(optionObject = {}) {
  const {
    count = 9, // 最多可以选择的图片张数
    sizeType = ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
    sourceType = ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
  } = optionObject;

  return new Promise((resolve, reject) => {
    wx.checkJsApi({
      jsApiList: ['chooseImage'], // 需要检测的JS接口列表
      success(res = {}) {
        const { checkResult = {} } = res;
        console.log(checkResult);
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        if (checkResult.chooseImage) {
          wx.chooseImage({
            count,
            sizeType,
            sourceType,
            async success(res1 = {}) {
              // 返回选定照片的本地文件路径列表，tempFilePath可以作为img标签的src属性显示图片
              const { localIds = [] } = res1;
              try {
                console.log('选择图片成功', res1);
                const token = await getToken();
                resolve({ localIds, token });
              } catch (error) {
                console.log('选择图片失败', error);
                reject({
                  type: FAIL_TYPES.API_FAIL.value,
                  errMsg: FAIL_TYPES.API_FAIL.desc,
                  info: error,
                });
                Vue.prototype.$toast.clear();
              }
            },
            fail(error) {
              console.log('chooseImage：失败', error);
              reject({
                type: FAIL_TYPES.API_FAIL.value,
                errMsg: FAIL_TYPES.API_FAIL.desc,
                info: error,
              });
            },
          });
        } else {
          Vue.prototype.$toast('当前微信版本不可用，请您升级微信');
          reject({
            type: FAIL_TYPES.UPLOAD_FAIL.value,
            errMsg: FAIL_TYPES.UPLOAD_FAIL.desc,
            info: res,
          });
        }
      },
      fail(err) {
        console.log('checkJsApi：失败', err);
        reject({
          type: FAIL_TYPES.API_FAIL.value,
          errMsg: FAIL_TYPES.API_FAIL.desc,
          info: err,
        });
        Vue.prototype.$toast(FAIL_TYPES.API_FAIL.desc);
      },
    });
  });
};
